module.exports = __webpack_public_path__ + "static/img/Jock-Landale.6afb389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jock-Landale.jpg
// module id = yJo+
// module chunks = 1